<template>
  <div>
    <div class="relative inline-block w-full text-left">
      <div>
        <div
          id="options-menu"
          type="button"
          class="inline-flex justify-between w-full min-w-full rounded-md border border-gray-300 shadow-sm px-3 py-2 bg-white text-sm font-medium text-gray-700  focus:outline-none focus:ring-2 focus:ring-offset-2"
          :class="disabled?'':'hover:bg-gray-50 cursor-default'"
          aria-haspopup="true"
          aria-expanded="true"
          @click="openDropdown = !openDropdown"
        >
          <div
            v-if="selectedType === null"
            class="text-gray-400"
          >
            <div v-if="placeholder === true">
              Type
            </div>
          </div>
          <div
            v-if="selectedType !== null"
            class="flex items-center"
          >
            <div
              class="rounded-full text-xs w-5 h-5 mr-2 leading-none select-none flex items-center justify-center text-white bg-gradient-to-t shadow border cursor-default"
              :class="GetBackground(selectedType)"
            >
              {{ GetChar(selectedType) }}
            </div>
            <div>{{ selectedType }}</div>
          </div>
          <!-- Heroicon name: chevron-down -->
          <div v-if="!disabled">
            <svg
              class="-mr-1 ml-2 h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div v-else>
            <i class="fas fa-lock text-gray-400" />
          </div>
        </div>
      </div>

      <div
        v-if="openDropdown && !disabled"
        class="origin-top-right absolute right-0 -mt-10 z-20 border w-full cursor-pointer rounded-md shadow-lg bg-white ring-1 ring-black max-h-32 overflow-y-scroll ring-opacity-5"
      >
        <div
          class="py-1"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
        >
          <div
            v-for="type in types"
            class="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
            @click="selectType(type)"
          >
            <div
              class="rounded-full text-xs w-5 h-5 mr-2 leading-none select-none flex items-center justify-center text-white bg-gradient-to-t shadow border cursor-default"
              :class="GetBackground(type)"
            >
              {{ GetChar(type) }}
            </div>
            <div>{{ type }}</div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="openDropdown"
      class="fixed top-0 left-0 z-10 min-w-full w-screen h-screen min-h-screen"
      @click="openDropdown = false;"
    />
  </div>
</template>

<script>
import { MapType, GetTypeChar, GetTypeBackground } from '@/app/shared/services/playerService/playerService';

export default {

  components: {

  },

  props: {
    type: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: null,
    },
    placeholder: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      openDropdown: false,
      selectedType: null,
    };
  },

  computed: {
    types() {
      const enums = [0, 1, 2, 3, 4, 5, 6];
      const types = [];
      for (let i = 0; i < enums.length; i++) {
        types.push(MapType(enums[i]));
      }
      return types;
    },
  },

  watch: {
    type() {
      this.initType();
    },
  },

  mounted() {
    this.initType();
  },

  methods: {
    selectType(type) {
      this.selectedType = type;
      this.openDropdown = false;
      for (let i = 0; i < this.types.length; i++) {
        if (this.types[i] === this.selectedType) {
          this.$emit('input', i);
        }
      }
    },

    initType() {
      if (this.type !== null) {
        this.selectedType = MapType(this.type);
      } else {
        this.selectedType = null;
      }
    },

    GetChar(type) {
      return GetTypeChar(type);
    },

    GetBackground(type) {
      return GetTypeBackground(type);
    },
  },

};
</script>
